import React from "react";
import { FaTrash } from "react-icons/fa";

function ProductTable({
    products,
    handleDeleteProduct,
    handleProductChange,
}) {
    const getTotal = (item) => {
        const qty = Number(item.quantity || 0);
        const price = Number(item.purchase_price || 0);
        const gst = Number(item.gst_percentage || item.gst || 0);
        const discount = Number(item.discount );

        const subtotal = qty * price;
        const gstAmount = (subtotal * gst) / 100;
        return subtotal + gstAmount - discount;
    };
    const handleKeyDown = (e) => {
        const allowedKeys = [
            "Backspace",
            "Delete",
            "Tab",
            "ArrowLeft",
            "ArrowRight",
            "Home",
            "End",
        ];

        // Allow control keys
        if (allowedKeys.includes(e.key)) {
            return;
        }

        // Allow only numbers and one decimal point
        if (!/^[0-9.]$/.test(e.key)) {
            e.preventDefault();
        }

        // Only one decimal allowed
        if (e.key === "." && e.target.value.includes(".")) {
            e.preventDefault();
        }
    };
    return (
        <div className="card shadow-sm border-0">
            <div className="custom-modal-header text-white">
                <h5 className="mb-0">Product List</h5>
            </div>

            <div className="st-wrapper-card text-center">
                <div className="st-table-responsive">
                    <table className="table st-custom-table align-middle mb-0">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Product</th>
                                <th>Qty</th>
                                <th>Purchase Price</th>
                                <th>GST %</th>
                                <th>Discount %</th>
                                <th>Total</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.length === 0 ? (
                                <tr>
                                    <td colSpan="8" className="text-center py-4 text-muted">
                                        No Product Added
                                    </td>
                                </tr>
                            ) : (
                                products.map((item, index) => (
                                    <tr key={index}>
                                          {/* <td> {(page - 1) * limit + index + 1}</td> */}
                                          <td> {index + 1}</td>
                                        <td>
                                            <strong className="text-nowrap">{item.product_name}</strong>
                                            {item.sku && (
                                                <div className="text-muted small">SKU: {item.sku}</div>
                                            )}
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                value={item.quantity}
                                                onKeyDown={handleKeyDown}
                                                onChange={(e) =>
                                                    handleProductChange(index, "quantity", e.target.value)
                                                }
                                                min="1"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                step="0.01"
                                                className="form-control form-control-sm"
                                                value={item.purchase_price}
                                                onKeyDown={handleKeyDown}
                                                onChange={(e) =>
                                                    handleProductChange(index, "purchase_price", e.target.value)
                                                }
                                                min="0"
                                            />
                                        </td>
                                        <td>
                                            {item.gst_percentage || 0}
                                        </td>
                                        {/* <td>
                                            <input
                                                type="text"
                                                step="0.01"
                                                className="form-control form-control-sm"
                                                value={item.gst_percentage || item.gst || 0}
                                                onChange={(e) =>
                                                    handleProductChange(
                                                        index,
                                                        "gst_percentage",
                                                        e.target.value
                                                    )
                                                }
                                                min="0"
                                                max="100"
                                            />
                                        </td> */}
                                      <td>
  <input
    type="text"
    className="form-control form-control-sm"
    placeholder="10%"
    value={item.discount || ""}
    onChange={(e) => {
      let value = e.target.value;

      // Sirf 0-100 aur last me optional %
      if (/^(100|[1-9]?\d)?%?$/.test(value)) {
        handleProductChange(index, "discount", value);
      }
    }}
  />
</td>
                                        <td className="fw-bold text-nowrap">
                                            ₹ {getTotal(item).toFixed(2)}
                                        </td>
                                        <td>
                                            <button
                                                className="st-action-btn st-delete-btn"
                                                onClick={() =>
                                                    handleDeleteProduct(index)
                                                }
                                            >
                                                <FaTrash />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default ProductTable;